export default __webpack_public_path__ + "static/newbooking-509f1ffcf570466b006376ce0d60e2dd.png";